import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.ensureTabsFocusable();
      this.observeTabChanges();
      this.setupKeyboardNavigation();
    }, 100);

    this.ensureTabsFocusable();
    this.setupKeyboardNavigation();
  }

  ensureTabsFocusable() {
    const tabLinks = this.element.querySelectorAll('.tabs-title a[role="tab"], .tabs-title a[data-tabs-target]');
    tabLinks.forEach((link) => {
      link.setAttribute('tabindex', '0');
    });
  }

  observeTabChanges() {
    const tabsElement = $(this.element);

    tabsElement.on('change.zf.tabs', () => {
      this.ensureTabsFocusable();
    });

    const observer = new MutationObserver((mutationList) => {
      mutationList.forEach((mutationRecord) => {
        if (mutationRecord.type === 'attributes' && mutationRecord.attributeName === 'tabindex') {
          const mutationTarget = mutationRecord.target;
          const isTabLink = mutationTarget.tagName === 'A' &&
            (mutationTarget.getAttribute('role') === 'tab' || mutationTarget.hasAttribute('data-tabs-target'));
          if (isTabLink && mutationTarget.getAttribute('tabindex') === '-1') {
            mutationTarget.setAttribute('tabindex', '0');
          }
        }
      });
    });

    const tabsList = this.element.querySelector('.tabs');
    if (tabsList) {
      observer.observe(tabsList, {
        attributes: true,
        attributeFilter: ['tabindex'],
        subtree: true
      });
    }

    this.intervalId = setInterval(() => {
      this.ensureTabsFocusable();
    }, 500);
  }

  setupKeyboardNavigation() {
    const tabLinks = this.element.querySelectorAll('.tabs-title a[role="tab"], .tabs-title a[data-tabs-target]');

    tabLinks.forEach((link) => {
      if (link._tabKeydownHandler) link.removeEventListener('keydown', link._tabKeydownHandler);

      link._tabKeydownHandler = (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          const currentIndex = Array.from(tabLinks).indexOf(event.currentTarget);
          const nextIndex = event.key === 'ArrowLeft'
            ? (currentIndex > 0 ? currentIndex - 1 : tabLinks.length - 1)
            : (currentIndex < tabLinks.length - 1 ? currentIndex + 1 : 0);

          tabLinks[nextIndex].focus();
        } else if (event.key === 'Enter') {
          event.preventDefault();
          this.activateTab(event.currentTarget);
        }
      };

      link.addEventListener('keydown', link._tabKeydownHandler);
    });
  }

  activateTab(tabLink) {
    const tabsElement = $(this.element);
    if (!tabsElement.length) return;

    const tabId = tabLink.getAttribute('data-tabs-target') || tabLink.getAttribute('href')?.replace('#', '');
    if (!tabId) return;

    if (tabsElement.data('zfPlugin') && tabsElement.data('zfPlugin').selectTab) {
      tabsElement.foundation('selectTab', tabId);
    } else {
      tabLink.click();
    }
  }

  disconnect() {
    if (this.intervalId) clearInterval(this.intervalId);

    const tabLinks = this.element.querySelectorAll('.tabs-title a[role="tab"], .tabs-title a[data-tabs-target]');
    tabLinks.forEach((link) => {
      if (link._tabKeydownHandler) {
        link.removeEventListener('keydown', link._tabKeydownHandler);
        delete link._tabKeydownHandler;
      }
    });
  }
}
